(function() {
  const MIN_QTY = 2;
  const MIN_ORDER_CENTS = 5000;

  function applyGuard(cart) {
    const totalQty = cart && typeof cart.item_count === 'number'
      ? cart.item_count
      : (cart?.items || []).reduce((s, i) => s + (i.quantity || 0), 0);

    const cartTotal = cart && typeof cart.total_price === 'number'
      ? cart.total_price
      : 0;

    const allowCheckout = totalQty >= MIN_QTY || cartTotal >= MIN_ORDER_CENTS;

    // Find any checkout buttons on cart page or mini-cart/drawer
    const checkoutButtons = Array.from(document.querySelectorAll(
      'form[action*="/cart"] [name="checkout"], a[href*="/checkout"]'
    ));

    checkoutButtons.forEach(btn => {
      // Always remove old guards first
      if (btn.dataset.minGuardBound && btn._minGuardHandler) {
        btn.removeEventListener('click', btn._minGuardHandler);
      }

      delete btn.dataset.minGuardBound;

      if (!allowCheckout) {
        btn._minGuardHandler = function(e) {
          e.preventDefault();

          alert('Orders require either 2 bottles or a $50 minimum to check out. Thanks for shopping!');

          const cartLink = document.querySelector('a[href="/cart"], a[href*="/cart?"]');
          if (cartLink) cartLink.focus();
        };

        btn.addEventListener('click', btn._minGuardHandler);
        btn.dataset.minGuardBound = '1';
      }
    });

    // Show a banner on cart page if the minimum has not been met
    const bannerId = 'min-two-banner';
    let banner = document.getElementById(bannerId);

    if (!allowCheckout) {
      const neededText = 'Orders require either 2 bottles or a $50 minimum to check out. Thanks for shopping!';

      if (!banner) {
        banner = document.createElement('div');
        banner.id = bannerId;
        banner.style.cssText = 'padding:12px;margin:10px 0;border:1px solid #ddd;border-radius:6px;background:#fffbe6;font-size:14px;text-align:center;';
        banner.textContent = neededText;

        const mount = document.querySelector('.cart__warnings, .cart__footer, .cart__items, main, .content') || document.body;
        mount.insertBefore(banner, mount.firstChild);
      } else {
        banner.textContent = neededText;
      }
    } else if (banner) {
      banner.remove();
    }
  }

  function refreshGuard() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(applyGuard)
      .catch(() => {
        // Fail-safe: do nothing if cart data cannot be loaded
      });
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', refreshGuard);

  // Re-run whenever quantities change
  document.addEventListener('change', function(e) {
    if (e.target && (e.target.name === 'updates[]' || e.target.closest('form[action="/cart"]'))) {
      setTimeout(refreshGuard, 150);
    }
  });

  // Re-run when common Shopify cart events fire
  ['cart:updated', 'ajaxCart:updated', 'cart:refresh'].forEach(evt =>
    document.addEventListener(evt, refreshGuard)
  );
})();